import { defineComponent } from "vue";

import { COMPONENT_NAME } from "./attributes";

export default defineComponent({
  name: COMPONENT_NAME,
  props: {
    value: {
      type: [String, Number],
      default: "",
    },
    maxValue: {
      type: [String, Number],
      default: 0,
    },
    label: {
      type: String,
      default: "",
    },
    isNumber: {
      type: Boolean,
      default: false,
    },
    isMaxValue: {
      type: Boolean,
      default: false,
    },
    isError: {
      type: Boolean,
      default: false,
    },
  },
  emits: {
    "update:value": null,
  },
  computed: {
    isErrorShow(): boolean {
      return this.isMaxValue && this.isError
        ? this.value > this.maxValue
        : false;
    },
  },
  methods: {
    changeValue(event: Event): void {
      const { value } = <HTMLInputElement>event.target;

      if (this.isNumber) {
        const filteredValue = value
          .replace(/[^0-9.]/g, "")
          .replace(/(\..*?)\..*/g, "$1");
        this.$emit("update:value", Number(filteredValue));
      } else {
        this.$emit("update:value", value);
      }
    },
    handleKeypress(event: KeyboardEvent): void {
      if (this.isNumber) {
        const charCode = event.charCode;
        const input = event.target as HTMLInputElement;

        // Проверяем, если вводится точка (charCode === 46) и она уже есть в значении
        if (charCode === 46 && input.value.includes(".")) {
          event.preventDefault();
          return;
        }

        // Запрещаем ввод любых символов, кроме цифр (48-57) и точки (46)
        if (
          charCode !== 0 &&
          (charCode < 48 || charCode > 57) &&
          charCode !== 46
        ) {
          event.preventDefault();
        }
      }
    },
  },
});
